import React, { useEffect, useRef, useState } from "react";
import Logo from "../../elements/logo/Logo";
import Nav from "../../common/header/Nav";
import StickyHeader from "./StickyHeader";
import { Link } from "react-router-dom";
import MobileMenu from "./MobileMenu";
import SEO from "../SEO";

const HeaderFour = () => {
  const sticky = StickyHeader(100);
  const isAuthenticated = localStorage.getItem("sUserid");
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const MobileMenuHandler = () => {
    document.querySelector(".mobilemenu-popup").classList.toggle("show");
    document.querySelector("body").classList.toggle("mobilemenu-show");

    var elements = document.querySelectorAll(
      ".mobilemenu-popup .menu-item-has-children > a"
    );

    for (var i in elements) {
      if (elements.hasOwnProperty(i)) {
        elements[i].onclick = function () {
          this.parentElement
            .querySelector(".axil-submenu")
            .classList.toggle("active");
          this.classList.toggle("open");
        };
      }
    }
  };

  return (
    <>
      <SEO />
      <style>
        {`
          /* HeaderFour.css */

          /* Main header styles */
          .headers {
            position: relative;
            z-index: 999;
          }

          .axil-mainmenu {
            padding: 15px 0;
            transition: all 0.3s ease;
            background-color: #fff;
          }

          .axil-mainmenu.sticky {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            animation: slideDown 0.5s forwards;
          }

          @keyframes slideDown {
            from {
              transform: translateY(-100%);
            }
            to {
              transform: translateY(0);
            }
          }

          /* Logo styles - Fixed stretching issue */
          .header-logo {
            max-width: 150px;
          }
          
          .header-logo img {
            max-width: 100%;
            height: auto;
            max-height: 50px;
            object-fit: contain;
          }
          
          @media (max-width: 575.98px) {
            .header-logo {
              max-width: 120px;
            }
            
            .header-logo img {
              max-height: 40px;
            }
          }

          /* Button styles */
          .btn-primary {
              background-color:#6600cc;
              border-color: #6600cc;
              color: white;
              border-radius: 4px;
              padding: 10px 20px;
              font-weight: 600;
              font-size: 15px;
              transition: all 0.3s ease;
              box-shadow: 0 2px 4px rgba(0, 128, 0, 0.3);
          }

          .btn-primary:hover {
              background-color: #006600;
              border-color: #006600;
          }

          .btn-outline-primary {
            border: 1px solid #6600cc;
            color: #6600cc;
            background-color: #fff;
            border-radius: 4px;
            padding: 10px 20px;
            font-weight: 600;
            font-size: 15px;
            transition: all 0.3s ease;
            box-shadow: 0 2px 4px rgba(102, 0, 204, 0.3);
            margin-left: 5px;
          }

          .btn-outline-primary:hover {
              background-color: #f0fff0;
              color: #006600;
              border: 1px solid #006600;
          }

          /* Dropdown styles */
          .dropdown {
            position: relative;
          }

          .dropdown-menu {
            position: absolute;
            background-color: white;
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
            min-width: 160px;
            border-radius: 8px;
            color: #6600cc;
            margin-top: 2px;
            overflow: hidden;
            animation: fadeIn 0.2s ease;
            border: 1px solid #eee;
            right: 0;
            display: none;
            opacity: 0;
            visibility: hidden;
            transition: all 0.2s ease;
            z-index: 1000;
          }

          .dropdown-menu span {
            color: #6600cc !important;
          }

          /* Show dropdown menu when active */
          .dropdown-menu.show {
            display: block;
            opacity: 1;
            visibility: visible;
          }

          /* Maintain hover effect for compatibility */
          .dropdown:hover .dropdown-menu {
            display: block;
            opacity: 1;
            visibility: visible;
          }

          .dropdown-item {
            padding: 12px 20px;
            display: block;
            color: #6600cc;
            text-decoration: none;
            font-size: 14px;
            transition: background-color 0.2s ease;
          }

          .dropdown-item:first-child {
            border-bottom: 1px solid #f5f5f5;
          }

          .dropdown-item:hover {
            background-color: #f0fff0;
            color:rgb(127, 28, 225);
          }

          /* Mobile menu button */
          .mobile-menu-btn .btn-wrap {
            position: relative;
            width: 24px;
            height: 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            cursor: pointer;
            background: transparent;
            border: none;
            padding: 0;
          }

          .mobile-menu-btn .btn-wrap span {
            display: block;
            width: 100%;
            height: 2px;
            background-color: #333;
            transition: all 0.3s ease;
          }

          /* Animations */
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* Responsive styles */
          @media (max-width: 991.98px) {
            .header-main-nav {
              display: none;
            }
            
            .try-free-btn {
              padding: 8px 16px;
              font-size: 14px;
            }
          }

          @media (max-width: 767.98px) {
            .dropdown {
              position: static;
            }
            
            .header-action {
              margin-left: auto;
            }
            
            .try-free-btn {
              padding: 6px 12px;
              font-size: 13px;
            }
            
            .login-btn {
              padding: 6px 12px;
              font-size: 13px;
            }
          }

          @media (max-width: 575.98px) {
            .axil-mainmenu {
              padding: 10px 0;
            }
          }
        `}
      </style>
      <header
        className={`headers axil-header header-style-4 ${
          sticky ? "sticky" : "sticky"
        }`}>
        <div className="axil-mainmenu sticky">
          <div className="container">
            <div className="header-navbar d-flex justify-content-between align-items-center">
              <div className="header-logo">
                <Logo
                  limage="/images/logo.png"
                  dimage="/images/logo.png"
                  simage="/images/logo.png"
                />
              </div>
              <div className="header-main-nav d-none d-lg-block">
                <Nav />
              </div>
              <div className="header-action">
                <ul className="list-unstyled d-flex align-items-center mb-0">
                  <li
                  // className="dropdown position-relative d-none d-md-block"
                  // ref={dropdownRef}
                  >
                    {/* <button className="btn btn-outline-primary login-btn">
                      <Link to={process.env.PUBLIC_URL + "/login"}>
                        <span className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#6600cc"
                            viewBox="0 0 16 16"
                            className="me-2">
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                            <path
                              fillRule="evenodd"
                              d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                            />
                          </svg>
                          Log In
                        </span>
                      </Link>
                    </button> */}
                    <div
                      className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
                      {/* <Link
                        to={process.env.PUBLIC_URL + "/login"}
                        className="dropdown-item">
                        <span className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#6600cc"
                            viewBox="0 0 16 16"
                            className="me-2">
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                            <path
                              fillRule="evenodd"
                              d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                            />
                          </svg>
                          Login
                        </span>
                      </Link> */}
                      {/* <Link
                        to={process.env.PUBLIC_URL + "/recruiterslogin"}
                        className="dropdown-item">
                        <span className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#6600cc"
                            viewBox="0 0 16 16"
                            className="me-2">
                            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                          </svg>
                          For Recruiters
                        </span>
                      </Link>
                      <Link
                        to={process.env.PUBLIC_URL + "/mentor-login"}
                        className="dropdown-item">
                        <span className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#6600cc"
                            viewBox="0 0 16 16"
                            className="me-2">
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                            <path
                              fillRule="evenodd"
                              d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                            />
                          </svg>
                          For Mentor
                        </span>
                      </Link>
                      <Link
                        to={process.env.PUBLIC_URL + "/instructor-login"}
                        className="dropdown-item">
                        <span className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#6600cc"
                            viewBox="0 0 16 16"
                            className="me-2">
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                            <path
                              fillRule="evenodd"
                              d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                            />
                          </svg>
                          For Instructor
                        </span>
                      </Link>
                      <Link
                        to={process.env.PUBLIC_URL + "/organizationlogin"}
                        className="dropdown-item">
                        <span className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#6600cc"
                            viewBox="0 0 16 16"
                            className="me-2">
                            <path d="M8.5 5.5a.5.5 0 0 0-1 0v.634l-.622-.312a.5.5 0 1 0-.447.894L7.5 6.945v.11l-1.69.845a.5.5 0 0 0 .447.894l2.17-1.085a.5.5 0 0 0 .276-.447V5.5z" />
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                          </svg>
                          For Organization
                        </span>
                      </Link> */}
                    </div>
                  </li>
                  <li className="header-btn ms-3">
                    <Link
                      to={process.env.PUBLIC_URL + "/login"}
                      className="btn btn-primary try-free-btn">
                      Log In
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                        className="ms-1">
                        <path
                          fillRule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                        />
                      </svg> */}
                    </Link>
                  </li>
                  {/* <li className="header-btn ms-3">
                    <button
                      onClick={handleDashboardNavigation}
                      className="btn btn-primary"
                    >
                      Dashboard
                    </button>
                  </li> */}
                  <li className="mobile-menu-btn d-lg-none d-block ms-3">
                    <button className="btn-wrap" onClick={MobileMenuHandler}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      <MobileMenu MobileHandler={MobileMenuHandler} />
    </>
  );
};
export default HeaderFour;
